import { Link } from '@/components/ui'

const MESSAGES = {
  missing: 'This case no longer exists.',
  failed: 'We could not load this case. Try again in a moment.',
}

export const CaseUnavailable = ({
  reason,
}: {
  reason: keyof typeof MESSAGES
}) => (
  <div className="space-y-3 py-20 text-center">
    <p className="font-medium text-lg">{MESSAGES[reason]}</p>
    <Link to="/tools/bankruptcy-screener">Back to the screener</Link>
  </div>
)
